import React, { useContext } from 'react'
import { RegistrationFormContext } from './types'
import { TextAreaElement } from '../../../../HtmlComponents/TextAreaElement'
import { InputElement } from '../../../../HtmlComponents/InputElement'
import { InputRadio } from '../../../../HtmlComponents/InputRadio'

const Section3 = () => {
  const { 
    highSchoolAccomplishments, setHighSchoolAccomplishments,
    educationalAchievements, setEducationalAchievements,
    dentalSchoolInformation, setDentalSchoolInformation,

    period, setPeriod,
    yearsOfSuccessfulStudy, setYearsOfSuccessfulStudy,
    dateOfGraduation, setDateOfGraduation,
    placeOfGraduation, setPlaceOfGraduation,
    type, setType,

    universityHospitalTitles, setUniversityHospitalTitles,
    advancedQualifications, setAdvancedQualifications,
    specialtyQualificationStatus, setSpecialtyQualificationStatus,
    supplementaryUniversityCertifications, setSupplementaryUniversityCertifications,
    distinctionsAndHonoraryTitles, setDistinctionsAndHonoraryTitles,
    otherUniversityDegrees, setOtherUniversityDegrees,

    specialtyCertificateInProgress, setSpecialtyCertificateInProgress,
   } = useContext(RegistrationFormContext)

  const diplomsType = ["D'etat", "D'Université"]

  return (
    <>    
      <TextAreaElement labelClass="text-main" labelName={`12) Précisez les dates et les noms des établissements fréquentes pendant vos études secondaires et supérieures (En dehors des études en médecine)`} value={highSchoolAccomplishments} setValue={setHighSchoolAccomplishments}/>
      <TextAreaElement labelClass="text-main" labelName={`13) precisez les diplomes obtenus, les date et les mentions accordees au decor des etudes dans les etablissements secondaires`} value={educationalAchievements} setValue={setEducationalAchievements}/>
      <TextAreaElement labelClass="text-main" labelName={`14) Précisez les facultés ou vous avez fait vos etudes de medecine dentaire.`} value={dentalSchoolInformation} setValue={setDentalSchoolInformation}/>
      <div>
        <p className='font-bold text-main'>{"15) "}Diplome de medecine dentaire</p>
        {/* <TextAreaElement labelClass="text-main" labelName={`15) Précisez les facultés ou vous avez fait vos etudes de medecine dentaire.`} value={dentalSchoolInformation} setValue={setDentalSchoolInformation}/> */}
        <InputElement name="Periode d'etudes" value={period} setValue={setPeriod}/>
        <InputElement name="Nombre d'années d'études réussies" value={yearsOfSuccessfulStudy} setValue={setYearsOfSuccessfulStudy}/>
        <InputElement type="date" name="Date d'obtention" value={dateOfGraduation} setValue={setDateOfGraduation}/>
        <InputElement name="Lieu d'obtention" value={placeOfGraduation} setValue={setPlaceOfGraduation}/>
        <p className='font-bold'>Type</p>
        <InputRadio 
          checked={type === "D'etat" && true} 
          labelName="D'etat"
          id="D'etat" 
          value={"D'etat"} 
          setValue={setType} 
        />
        <InputRadio 
          checked={type === "D'Université" && true} 
          labelName="D'Université"
          id="D'Université" 
          value={"D'Université"} 
          setValue={setType} 
        />
        <InputRadio 
          checked={(type && !diplomsType.includes(type)) ? true : false} 
          labelName="Autres"
          id="Autres" 
          value={"Autres"} 
          setValue={setType} 
        />
        {(type && !diplomsType.includes(type)) && <InputElement name="Preciser" value={type} setValue={setType}/>}
        {/* <InputElement name="Type" value={type} setValue={setType}/> */}
      </div>
      <TextAreaElement labelClass="text-main" labelName={`16) Titres universitaires et hospitaliere`} value={universityHospitalTitles} setValue={setUniversityHospitalTitles}/>
      <TextAreaElement 
        labelClass="text-main"
        labelName={`17) Diplomes de specialité ou qualifiants.`}
        placeholder={`Detailler pour chacun, la periode d'etudes, le nombre d'années d'études reussies, la date d'obtention, la facilite le lieu d'obtention est fourni les pièces justifications.`}
        value={advancedQualifications}
        setValue={setAdvancedQualifications}
      />
      <TextAreaElement 
        labelClass="text-main"
        labelName={`18) Qualifications de spécialité demandée ou déja accordé par l'ordre.`}
        placeholder={`Qualification de spécialité demandée ou déjà accordée par l'ordre. (Au regard du diplôme. De spécialité obtenue ou obtenue Après une formation et une expérience qui assurent Des compétences équivalentes à celles qui sont requises pour l'obtention du diplôme de la spécialité sollicitée).`}
        value={specialtyQualificationStatus}
        setValue={setSpecialtyQualificationStatus}
      />
      <TextAreaElement 
        labelClass="text-main"
        labelName={`19) Diplôme ou attestation ou certificat délivres Par l'université en dehors des diplômes donnant droit à la qualification.`}
        placeholder={`Détaillé pour chacun la période d'étude, le nombre d'années d'études, réussies, la date d'obtention, la faculté, le lieu d'obtention et fourni les pièces justificatives.`}
        value={supplementaryUniversityCertifications}
        setValue={setSupplementaryUniversityCertifications}
      />
      <TextAreaElement 
        labelClass="text-main"
        labelName={`20) Précisez les distinctions et titres honorifiques. Les prix obtenus, les titres de par la faculté.(Lauréat de la faculté), La qualité des membres des sociétés savantes.`}
        placeholder={`Détaillé pour chacun la période d'étude, le nombre d'années d'études, réussies, la date d'obtention, la faculté, le lieu d'obtention et fourni les pièces justificatives.`}
        value={distinctionsAndHonoraryTitles}
        setValue={setDistinctionsAndHonoraryTitles}
      />
      <TextAreaElement 
        labelClass="text-main"
        labelName={`21) Enumérer Les autres diplômes universitaires du niveau au moins de la licence obtenue (Justificatif à fournir) .`}
        placeholder={`Détaillé pour chacun la période d'étude, le nombre d'années d'études, réussies, la date d'obtention, la faculté, le lieu d'obtention et fourni les pièces justificatives.`}
        value={otherUniversityDegrees}
        setValue={setOtherUniversityDegrees}
      />
      <TextAreaElement labelClass="text-main" labelName={`22) Préparez-vous actuellement en certificat de spécialité. Si oui, lequel`} value={specialtyCertificateInProgress} setValue={setSpecialtyCertificateInProgress}/>    
    </>
  )
}

export default Section3